// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import {
    AccountShipToCollectionModel,
    AccountShipToModel,
    CostCodeDto,
    CostCodeModel,
    CustomerCostCodeDto,
    PaginationModel,
} from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface AccountShipTosState {
    readonly dataViews: SafeDictionary<CustomDataView>;
}

interface CustomDataView {
    readonly isLoading: boolean;
    pagination: PaginationModel | null;
    value?: AccountShipToModel[];
    properties?: { [key: string]: string };
    costCodesCollection?: CustomerCostCodeDto[] | null;
}

const initialState: AccountShipTosState = {
    dataViews: {},
};

const reducer = {
    "Data/AccountShipTos/BeginLoadAccountShipToCollection": (
        draft: Draft<AccountShipTosState>,
        action: { parameter: object },
    ) => {
        draft.dataViews[getDataViewKey(action.parameter)] = {
            isLoading: true,
            pagination: null,
        };
    },
    "Data/AccountShipTos/CompleteLoadAccountShipToCollection": (
        draft: Draft<AccountShipTosState>,
        action: { parameter: object; collection: AccountShipToCollectionModel },
    ) => {
        const dataView = {
            isLoading: false,
            value: action.collection.userShipToCollection!,
            pagination: action.collection.pagination,
            // XNG-Changes: add those params to be loaded in the state
            properties: action.collection.properties,
            costCodesCollection: action.collection.costCodeCollection,
        };

        draft.dataViews[getDataViewKey(action.parameter)] = dataView;
    },
    "Data/AccountShipTos/Reset": () => {
        return initialState;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);

const xAccountShipTos = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xAccountShipTos = xAccountShipTos;

export type xAccountShipTosState = {
    xAccountShipTos: AccountShipTosState;
} & ApplicationState;
